module.exports = __webpack_public_path__ + "static/twitter-icon-d31e7eac9789e0b555db25f93c814d54.png";